import React, { useEffect, useState } from 'react'
import './TrackerStepDeskTop.css'
import { getMappedValue } from '../../utils/arabicUtils'

const TrackerStepDeskTop = ({ details, tripId, isPWA }) => {
  const [isShown, updateTrackerShow] = useState(true)
  useEffect(() => {
    if (
      details &&
      details.progressBar &&
      details.progressBar.length &&
      details.progressBar[details.progressBar.length - 1] &&
      details.progressBar[details.progressBar.length - 1].status === '1'
    ) {
      updateTrackerShow(!isShown)
    }
  }, [])
  return (
    <If condition={isShown}>
      <div className="expandable open br-4 bg-white-f7 mx-1">
        <div className="flex mb-3 mt-4">
          {details.progressBar.map((step, index) => {
            let fourStepClass = 'w-33p'
            if (index === 0 || (index === 3 && details.progressBar.length)) {
              fourStepClass = 'w-1665p'
            }
            return (
              <>
                <div
                  className={`${details.progressBar.length === 4 ? fourStepClass : ''} ${
                    details.progressBar.length === 3 ? 'w-33p' : ''
                  } ${details.progressBar.length === 2 ? 'w-50p' : ''}`}
                >
                  <div className="flex">
                    <div
                      className={`step-buffer ${index === 0 ? 'start-buffer' : ''} ${
                        index === details.progressBar.length - 1 ? 'start-line' : ''
                      }`}
                    >
                      <div />
                      <div />
                    </div>
                    <div
                      className={`step-circle
                      ${step.status && step.status === '0' ? 'active-step' : ''}
                      ${step.status && step.status === '1' ? 'finished-step' : ''}
                      ${step.status && step.status === '2' ? 'failed-step' : ''}`}
                    />
                    <div
                      className={`step-buffer ${index === 0 ? 'end-line' : ''}
                      ${index === details.progressBar.length - 1 ? 'end-buffer' : ''}`}
                    >
                      <div />
                      <div />
                    </div>
                  </div>
                  <div
                    className={`step-tag us-text
                    ${step.status && step.status === '0' ? 'active-tag' : ''}
                    ${index === 0 ? 'ta-l' : ''}
                    ${index === details.progressBar.length - 1 ? 'ta-r' : ''}`}
                  >
                    {getMappedValue(step.tag)}
                  </div>
                  <If condition={step.dueMsgs && step.dueMsgs.length}>
                    <div
                      className={`step-description us-text
                        ${index === 0 ? 'ta-l' : ''}
                        ${index === details.progressBar.length - 1 ? 'ta-r' : ''}`}
                    >
                      {getMappedValue(step.dueMsgs.join(' '))}
                    </div>
                  </If>
                  <If condition={step.msg && step.msg.length}>
                    {step.msg.map((stepMsg, idx) => (
                      <div
                        key={idx}
                        className={`step-description us-text
                        ${index === 0 ? 'ta-l' : ''}
                        ${index === details.progressBar.length - 1 ? 'ta-r' : ''}`}
                      >
                        {getMappedValue(stepMsg)}
                      </div>
                    ))}
                  </If>
                  {/* <If condition={step.dueMsgs && step.dueMsgs.length > 0}>
                    <p
                      className={`${isPWA ? 'fs-13' : 'fs-caption-2'} tt-sentence
                         'c-grey-30'
                       pt-1`}
                    >
                      {step.dueMsgs.join(' ')}
                    </p>
                  </If> */}
                </div>
              </>
            )
          })}
        </div>
        <If condition={!isPWA && details.message && details.message.length > 0}>
          <div className="fs-body color-8a py-1">
            <p className="fs-14 fw-600 c-neutral-500">{getMappedValue(details.status)}</p>
            <p className="fs-12">{getMappedValue(details.message.join(' '))}</p>
          </div>
        </If>
      </div>
    </If>
  )
}

export default TrackerStepDeskTop
